import React, { ComponentType } from 'react';
import Ribbon from 'components/ribbons/Ribbon';
import visibilitySet from 'presentation/hocs/visibilitySet';
import errorBoundary from 'presentation/hocs/errorBoundary';
import { RibbonProps, Type } from 'domain/constants/ribbons';
import Background, { BackgroundArray } from 'components/common/Background';

interface OuterProps extends RibbonProps {
  layers: BackgroundArray;
}

export const PurePoster = ({ id, colorway, layers, loading, layout, name }: OuterProps) => (
  <Ribbon id={id} colorway={colorway} loading={loading} layout={layout} name={name} type={Type.POSTER}>
    <Background background={layers} layout={layout} colorway={colorway} hideGradient={true} />
  </Ribbon>
);

PurePoster.displayName = 'Poster';

export default visibilitySet(errorBoundary(PurePoster)) as ComponentType<OuterProps>;
